{
  "schemaVersion": 1,
  "kind": "mallard-proxy-physical-float-study-profile",
  "assetSHA256": "146b088f1b126694ea1f6a2c8d9f78fe7c83a9d78493941386431a6757f572be",
  "authoredSequenceSHA256": "0d6af47a6cdbb50f78f55250861afd97c16d5414e83b44855f27a78a3af3686f",
  "sourceMotionAuditSHA256": "e6ad27508f0ab401a67d1e0102c15f7e933f3421475a543438f6de4c3204d864",
  "units": "metres",
  "up": "+Y",
  "forward": "-Z",
  "identity": {
    "common": "Mallard, adult drake breeding plumage",
    "scientific": "Anas platyrhynchos",
    "scope": "Photo-guided modeled phenotype, not a scan or measured individual"
  },
  "neutralAllGeometryBounds": {
    "min": [
      -0.09521560370922089,
      0.0024720457591220174,
      -0.21079036058981906
    ],
    "max": [
      0.09522151947021484,
      0.3298454155697581,
      0.2749999833684522
    ]
  },
  "coreBounds": {
    "min": [
      -0.09521560370922089,
      0.07272464686960808,
      -0.21079036058981906
    ],
    "max": [
      0.09522151947021484,
      0.3298454155697581,
      0.24987877455674964
    ]
  },
  "authoredSweptBounds": {
    "bank-two-step-settle": {
      "min": [
        -0.09921560436487198,
        -3.003515303134918e-08,
        -0.41109609603881836
      ],
      "max": [
        0.09922152012586594,
        0.3273734450340271,
        0.2750000059604645
      ]
    },
    "floating-paddle-idle": {
      "min": [
        -0.09521560370922089,
        -0.06158331781625748,
        -0.41479039192199707
      ],
      "max": [
        0.09522151947021484,
        0.3298454284667969,
        0.2750000059604645
      ]
    }
  },
  "float": {
    "waterlineYMetres": 0.13,
    "rootPlacement": "rootY = actual surface water height minus 0.130 * worldUnitsPerMetre * seededUniformVariation; keep bank grounding a separate domain.",
    "neutralBodyPitchRadians": 0,
    "neutralBodyRollRadians": 0,
    "orientationScope": "Neutral authored pose only. Any surface-normal tilt/heave requires its own swept skin/environment checks.",
    "sections": [
      {
        "waterlineYMetres": 0.12,
        "hullDraftMetres": 0.04727535313039191,
        "intersectionSegments": 93,
        "closedDegreeTwoSection": true,
        "loops": [
          {
            "vertices": 93,
            "planarAreaSquareMetres": 0.03700591944804811,
            "bounds": {
              "min": [
                -0.08695486344637325,
                0.12,
                -0.07508472536367793
              ],
              "max": [
                0.08691733470380558,
                0.12,
                0.19268509227696834
              ]
            }
          }
        ],
        "sectionBounds": {
          "min": [
            -0.08695486344637325,
            0.12,
            -0.07508472536367793
          ],
          "max": [
            0.08691733470380558,
            0.12,
            0.19268509227696834
          ]
        },
        "submergedCoreVertices": 193,
        "coreVertexCount": 1598
      },
      {
        "waterlineYMetres": 0.13,
        "hullDraftMetres": 0.05727535313039192,
        "intersectionSegments": 100,
        "closedDegreeTwoSection": true,
        "loops": [
          {
            "vertices": 100,
            "planarAreaSquareMetres": 0.0419134693292219,
            "bounds": {
              "min": [
                -0.09145151256614,
                0.13,
                -0.08410470806364742
              ],
              "max": [
                0.0916015182126595,
                0.13,
                0.2033465581847903
              ]
            }
          }
        ],
        "sectionBounds": {
          "min": [
            -0.09145151256614,
            0.13,
            -0.08410470806364742
          ],
          "max": [
            0.0916015182126595,
            0.13,
            0.2033465581847903
          ]
        },
        "submergedCoreVertices": 237,
        "coreVertexCount": 1598
      },
      {
        "waterlineYMetres": 0.14,
        "hullDraftMetres": 0.06727535313039193,
        "intersectionSegments": 101,
        "closedDegreeTwoSection": true,
        "loops": [
          {
            "vertices": 101,
            "planarAreaSquareMetres": 0.04568941473170434,
            "bounds": {
              "min": [
                -0.0940661869604827,
                0.14,
                -0.09125737715301903
              ],
              "max": [
                0.09402707950422529,
                0.14,
                0.2144172971010762
              ]
            }
          }
        ],
        "sectionBounds": {
          "min": [
            -0.0940661869604827,
            0.14,
            -0.09125737715301903
          ],
          "max": [
            0.09402707950422529,
            0.14,
            0.2144172971010762
          ]
        },
        "submergedCoreVertices": 280,
        "coreVertexCount": 1598
      }
    ],
    "sectionScope": "Actual rest exported Mallard_core geometry intersected by a horizontal plane. A closed section is a geometric check only; no mass, water displacement, pressure or restoring torque solved.",
    "actualAuthoredWebExtrema": {
      "L": {
        "minWebYMetres": -0.058332499116659164,
        "maxWebYMetres": 0.15031376481056213,
        "minSubmergedVertexFraction": 0.9388379204892966,
        "maxSubmergedVertexFraction": 1.0
      },
      "R": {
        "minWebYMetres": -0.05838148295879364,
        "maxWebYMetres": 0.15031598508358002,
        "minSubmergedVertexFraction": 0.9357798165137615,
        "maxSubmergedVertexFraction": 1.0
      }
    },
    "maximumAllGeometryDepthBelowWaterlineMetres": 0.19158331781625748
  },
  "reference": {
    "path": "references/lavalle-floating.jpg",
    "sha256": "16e8dcda59343d1eab24708d77a93dcdcd20b147a855345a2f57bda7db587d7a",
    "url": "https://www.fws.gov/media/mallard-floating-water-billy-frank-jr-nisqually-national-wildlife-refuge",
    "credit": "LaValle / USFWS, public-domain source photograph",
    "scope": "Actually inspected oblique floating adult drake. Supports flank/chest immersion and concealed proximal legs qualitatively. Perspective, reflected surface and unknown submerged hull prevent calibrated draft/roll measurement."
  },
  "limits": [
    "Waterline0.130m and zero pitch/roll remain illustrative engineering alignment, pending actual habitat comparison.",
    "No buoyancy, load, mass, propulsion or finite support-patch validation.",
    "Bank and water actions remain separate; no shore transition or flight.",
    "Source motion ranges are authored diagnostics, not biological cadence.",
    "Proxy-specific sections and source-key swept bounds are measured here; independent native continuous contact remains required."
  ],
  "comparisonToFull14b": {
    "fullAssetSHA256": "ce5988b4338b821e2b913b2ddad5a84c2f0cd4d7499c3c01af4be5cc636078ff",
    "fullProfileSHA256": "68a48dad63feb693f653432d132fa411c9f7144007c545c77efb06e35185f00b",
    "waterlineYMetres": 0.13,
    "sectionSpanXZMetres": {
      "full": [
        0.1830904034900309,
        0.2876230625155123
      ],
      "proxy": [
        0.18305303077879947,
        0.28745126624843775
      ]
    },
    "proxyDraftMetres": 0.05727535313039192,
    "fullDraftMetres": 0.05727535313039192,
    "scope": "Geometric engineering comparison, not buoyancy or biological immersion calibration."
  },
  "authoredSweptBoundsSampling": {
    "method": "Actual Blender proxy skin at all frozen15a keys; all173 bank keys and169 water keys.",
    "betweenKeyGuarantee": false
  }
}
